import { useQuery } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

async function getGroupServiceCategory({ categoryId }) {
  const response = await axiosPrivate.get(`/v3/pharmacist/service-categories/${categoryId}`);
  return response.data;
}

export default function useGetGroupServiceCategory({ categoryId }) {
  return useQuery({
    queryKey: ['groupServiceCategory', categoryId],
    queryFn: () => getGroupServiceCategory({ categoryId }),
    enabled: !!categoryId && categoryId !== 'new-category',
  });
}
